(function($) {

   var switchesSwitch = $('.content-switcher .switches-switch');
   var contentSwitch = $('.content-switcher .content-switch');

   switchesSwitch.on('click', function() {
      var otherSwitcher = $(this).closest('.content-switches').hide().siblings('.content-switches').show();
      otherSwitcher.find('.content-switch:nth-of-type(1)').click();
      $('html, body').animate({scrollTop: 0}, 400);
   });

   contentSwitch.on('click', function() {
      var target = $(this).data('tab');

      if ($(this).hasClass('click-supporter-next')) {
         $('.supporter-form-next-step').click();
         return;
      }

      if ($(this).hasClass('click-membership-payment-next')) {
         $('.membership-payment-form-next-step').click();
         return;
      }

      if ($(this).hasClass('click-membership-next')) {
         // $('.membership-form-next-step1').click();
         return;
      }

      contentSwitch.removeClass('active');
      $(this).addClass('active');

      $('.content-tab').removeClass('active');
      $('.content-tab-' + target).addClass('active');

      $('html, body').animate({scrollTop: 0}, 400);

   });

})( jQuery );